exports.components = {
  "component---src-pages-e-ticket-js": () => import("./../../../src/pages/e-ticket.js" /* webpackChunkName: "component---src-pages-e-ticket-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

